<div class="filterByTimeRangeContainer" *ngIf="selectedOutlookFilter?.name === 'filterByTime'">
    <div class="row" *transloco="let translate">
        <div class="col-4">
            <material-input-date
                [placeholder]="translate('From Date')"
                [label]="translate('From Date')"
                [id]="'processStartingDate'"
                [title]="timeFilter.startDate || translate('From Date')"
                [model]="timeFilter.startDate"
                [inputOnlyDisabled]="true"
                [minDate]="minDate"
                [minDateFormat]="minDateFormat"
                [required]="required"
                (modelChange)="timeFilter.startDate = $event"></material-input-date>
        </div>
        <div class="col-4">
            <mat-form-field>
                <mat-label *ngIf="isIE || !isIE">Start Time</mat-label>
                <ng-container *ngIf="isIE && timeFilter.startTime; else noTime">
                    <input matInput [(ngModel)]="timeFilter.startTime" readonly [required]="required" />
                </ng-container>
                <ng-template #noTime>
                    <input matInput [ngxTimepicker]="StartTimePick" [(ngModel)]="timeFilter.startTime" [min]="minTime" readonly [required]="required" />
                </ng-template>
                <material-button buttonType="mini-fab" [size]="'small'" [hideRipple]="true" matSuffix tabindex="-1" class="timePick">
                    <ngx-material-timepicker-toggle [for]="StartTimePick"></ngx-material-timepicker-toggle>
                </material-button>
                <ngx-material-timepicker
                    #StartTimePick
                    [theme]="darkTheme"
                    (timeChanged)="timeFilter.startTime = $event"></ngx-material-timepicker>
                <mat-hint align="start" *ngIf="required">
                    <strong>
                        <span>*</span>
                        <span>{{ translate('Required') }}</span>
                    </strong>
                </mat-hint>
            </mat-form-field>
        </div>
    </div>
    <div class="row" *transloco="let translate">
        <div class="col-4">
            <material-input-date
                [placeholder]="translate('To Date')"
                [label]="translate('To Date')"
                [title]="timeFilter.endDate || translate('To Date')"
                [id]="'processEndDate'"
                [model]="timeFilter.endDate"
                [inputOnlyDisabled]="true"
                [minDate]="minDate"
                [minDateFormat]="minDateFormat"
                [required]="required"
                (modelChange)="timeFilter.endDate = $event"></material-input-date>
        </div>
        <div class="col-4">
            <mat-form-field>
                <mat-label *ngIf="isIE || !isIE">End Time</mat-label>
                <ng-container *ngIf="isIE && timeFilter.endTime; else noEndTime">
                    <input matInput [(ngModel)]="timeFilter.endTime" readonly [required]="required" />
                </ng-container>
                <ng-template #noEndTime>
                    <input matInput [ngxTimepicker]="endTimePick" [(ngModel)]="timeFilter.endTime" readonly [required]="required" />
                </ng-template>
                <material-button buttonType="mini-fab" [size]="'small'" matSuffix tabindex="-1" class="timePick" [hideRipple]="true">
                    <ngx-material-timepicker-toggle [for]="endTimePick"></ngx-material-timepicker-toggle>
                </material-button>
                <ngx-material-timepicker
                    #endTimePick
                    [theme]="darkTheme"
                    (timeChanged)="timeFilter.endTime = $event"></ngx-material-timepicker>
                <mat-hint align="start" *ngIf="required">
                    <strong>
                        <span>*</span>
                        <span>{{ translate('Required') }}</span>
                    </strong>
                </mat-hint>
            </mat-form-field>
        </div>
    </div>
</div>
